@import "../../../../shared/scss";

:host {
  display: block;
  position: fixed;
  inset-block-start: 0;
  translate: calc(var(--isLTR, 1) * -1000p);
  block-size: 100vh;
  inline-size: 100vw;
  z-index: $phn-z-index-mega-flyout + 1;
  background-color: $pds-theme-light-background-base;

  &.translate-in-from-left {
    position: absolute;
    @media (prefers-reduced-motion: no-preference) {
      animation: translate-in-from-left $pds-motion-duration-long
        $pds-motion-easing-in;
    }
  }

  &.translate-out-to-left {
    position: absolute;
    @media (prefers-reduced-motion: no-preference) {
      animation: translate-in-from-left $pds-motion-duration-long
        $pds-motion-easing-out reverse;
    }
  }

  .drawer {
    z-index: $phn-z-index-mega-flyout + 1;
    background-color: $pds-theme-light-background-base;
    position: absolute;
    inset-inline-start: 0;

    .drawer-content {
      overflow-y: auto;
      overflow-block: auto;
      block-size: 100vh;
      overscroll-behavior-block: contain; // disable pull to refresh
      inline-size: 100vw;
      box-sizing: border-box;
      padding-block: 0;
      scrollbar-gutter: stable;
      position: relative;

      &:has(phn-nd-car-body-types-drawer) {
        overflow-block: scroll;
      }

      @include pds-media-query-min("s") {
        padding-block: 0;
        padding-inline: p-px-to-rem(54px);
      }

      @include pds-media-query-min("m") {
        padding-block: 0;
        padding-inline: p-px-to-rem(36px);
      }

      phn-nd-drawer-header {
        box-sizing: border-box;
        padding-block-start: p-px-to-rem(18px);
        padding-block-end: $pds-spacing-static-medium;
        padding-inline: p-px-to-rem(27px);

        position: sticky;
        inset-block-start: 0;
        background: $pds-theme-light-background-base;
        outline: 2px solid $pds-theme-light-background-base;
        z-index: 2;
        margin-block-end: 6px;
      }

      phn-nd-router:not(:has(phn-nd-car-body-types-drawer)) {
        padding-block-end: 4rem;
      }

      .first-focus {
        visibility: hidden;
      }
    }

    @supports (height: 100dvh) {
      .drawer-content {
        block-size: 100dvh; // Account for mobile nav bars at the bottom
      }
    }
  }

  &:has(phn-model-tile) {
    phn-nd-signature-heading {
      padding-block-start: 0 !important;

      phn-p-model-signature {
        block-size: p-px-to-rem(32px);
      }
    }
  }
}
